var _excluded = ["locale", "theme"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as yogaTokens from '@gympass/yoga-tokens';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import yogaThemeBuilder from '../theme';
/**
 *
 * @param {Function} builder theme builder function, returns an object with custom theme tokens
 * @param {Object.<string, string | number>} tokens default tokens from standard Yoga theme
 * @returns {null | Object.<string, string | number>} null if there's no builder, otherwise return custom tokens
 */

var getBuilderTokens = function getBuilderTokens(builder, tokens) {
  if (!builder) {
    return {};
  }

  var isThemeInvalid = builder ? !('isFromThemeBuilder' in builder) : false;

  if (isThemeInvalid) {
    throw new TypeError("Invalid 'theme' parameter. Expected one generated by createTheme() function.\n    Did you sent a function directly to <ThemeProvider />?\n    ");
  }

  var customTokens = builder(tokens);

  if (typeof customTokens !== 'object') {
    throw TypeError("Invalid 'theme' return value. Expected 'object', got " + typeof builder(tokens) + ".");
  }

  return customTokens;
};
/**
 * Gets resolved theme to inject in Yoga
 *
 * @param {{locale: string, theme: function}} themeParameters information about the theme
 * @param {string} themeParameters.locale custom locale to get colors from (if it has a different scheme)
 * @param {function} themeParameters.theme returns a custom theme object to replace existing tokens
 * @returns {Object.<string, string | number>} theme object with tokens sent to styled-components' <ThemeProvider />
 */


var getTheme = function getTheme(_ref) {
  var locale = _ref.locale,
      theme = _ref.theme;
  var tokens = yogaTokens[locale] || yogaTokens["default"];
  var customTokens = getBuilderTokens(theme, tokens);
  return yogaThemeBuilder(tokens, customTokens);
};
/** This component provides a theme to all React components underneath itself via the context API. */


var Provider = function Provider(_ref2) {
  var locale = _ref2.locale,
      theme = _ref2.theme,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(ThemeProvider, _extends({
    theme: {
      yoga: getTheme({
        locale: locale,
        theme: theme
      })
    }
  }, rest));
};

Provider.propTypes = {
  locale: PropTypes.string
};
Provider.defaultProps = {
  locale: 'pt-BR'
};
export default Provider;